import React from 'react';

const HowItWorks = () => {
  const steps = [
    {
      number: '01',
      gradient: 'from-hector-blue to-cyan-400',
      title: 'Apply Online',
      description: 'Fill out a quick form. Tell us who you are and what part of the Amazon ecosystem you serve. Takes 5 minutes.',
      note: '(No gatekeeping. We say yes to 98% of applicants.)'
    },
    {
      number: '02',
      gradient: 'from-hector-purple to-pink-400',
      title: 'Get Your Affiliate Link',
      description: 'We send you a unique referral URL + dashboard access. You can start sharing immediately.',
      note: null
    },
    {
      number: '03',
      gradient: 'from-green-400 to-cyan-400',
      title: 'Refer Brands to Hector',
      description: 'Send a text, email, Slack message, or LinkedIn post to anyone in your network who\'s struggling with Amazon ads. They click your link. They sign up. Done.',
      note: null
    },
    {
      number: '04',
      gradient: 'from-yellow-400 to-orange-400',
      title: 'Earn Commission Every Month',
      description: 'We handle onboarding, support, and retention. You get paid 30 days after their first charge and every month after that, automatically.',
      note: null
    }
  ];

  return (
    <section id="how-it-works" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center max-w-4xl mx-auto mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-hector-black mb-6">
            Getting Started Takes <span className="bg-gradient-to-r from-hector-blue to-hector-purple bg-clip-text text-transparent">15 Minutes</span>
          </h2>
        </div>
        
        <div className="max-w-5xl mx-auto">
          {steps.map((step, index) => (
            <div key={index}>
              <div className="flex flex-col md:flex-row items-start md:items-center mb-12">
                <div className="flex-shrink-0 mb-6 md:mb-0">
                  <div className={`w-20 h-20 bg-gradient-to-br ${step.gradient} rounded-2xl flex items-center justify-center text-white font-bold text-3xl shadow-lg`}>
                    {step.number}
                  </div>
                </div>
                <div className="md:ml-8 flex-1">
                  <div className="bg-gradient-to-br from-white to-hector-light-grey rounded-2xl p-8 shadow-lg">
                    <h3 className="text-2xl font-bold text-hector-black mb-4">{step.title}</h3>
                    <p className="text-gray-600 leading-relaxed mb-3">
                      {step.description}
                    </p>
                    {step.note && (
                      <p className="text-hector-purple font-semibold">
                        {step.note}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              
              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div className={`hidden md:block w-1 h-12 ml-10 mb-12 bg-gradient-to-b ${step.gradient}`}></div>
              )}
            </div>
          ))}
        </div>
        
        {/* CTA */}
        <div className="text-center mt-16 space-y-4">
    <a 
  href="https://hector.partnerstack.com/" 
  target="_blank" 
  rel="noopener noreferrer"
  className="inline-block"
>
  <button 
    className="cta-button px-8 py-4 rounded-xl font-semibold text-white text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 w-auto inline-block"
    style={{
      background: "linear-gradient(90deg, #CC2EF4 0%, #3E2EF4 100%)",
    }}
  >
    GET YOUR AFFILIATE LINK NOW
  </button>
</a>

          <p className="text-sm text-gray-600">
            Apply now. Start referring immediately. <span className="font-bold text-hector-black">Get paid in 30 days.</span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
